{
  "version": 1,
  "asset_id": "84545cc9-c070-4d8a-90ac-02de8e0fbf59",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/84545cc9-c070-4d8a-90ac-02de8e0fbf59/foreignaffairs-semrush-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/84545cc9-c070-4d8a-90ac-02de8e0fbf59/foreignaffairs-semrush-1280.webp",
  "original_filename": "foreignaffairs-semrush-1280.webp",
  "size": 38414,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:57Z"
}
